import { DimeToggle } from '../DimeToggle.js';

/** A filter heading's Select All, pressed while every option is picked. */
export function DimeFilterSelectAllToggle({
  pressed,
  onPressedChange,
  label,
}: Readonly<{ pressed: boolean; onPressedChange: () => void; label: string }>) {
  return (
    <DimeToggle
      size="sm"
      variant="outline"
      className="h-6 shrink-0 px-2 text-xs font-normal"
      pressed={pressed}
      onPressedChange={onPressedChange}
      aria-label={`Select All ${label}`}
    >
      Select All
    </DimeToggle>
  );
}
